import MainView from "../../views/MainView";
import EntitySystem from "../systems/EntitySystem";
import EntityFactory from "../systems/EntityFactory";
import Point3D from "../math/Point3D";
import C_Snd from "../../const/C_Snd";
import C_Comm from "../const/C_Comm";
import C_GameEvt from "../const/C_GameEvent";
import io from "socket.io-client";
import RoomSelectView from "../../views/RoomSelectView";
import FlierLogic from "../components/FlierLogic";
import Physics from "../components/Physics";
import C_ViewType from "../../const/C_ViewType";
import PaytableWin from "../../views/PaytableWin";
import GameOverWin from "../../views/GameOverWin";
import FlierData from "../model/FlierData";
import TypeSelectView from "../../views/TypeSelectView";
import C_Entity from "../../const/C_Entity";
import MathUtil from "../utils/MathUtil";
import ConfirmWin from "../../views/ConfirmWin";
import SplashScreen from "../../views/SplashScreen";
import GameSprite from "../components/GameSprite";
import C_FormationType from "../../const/C_FormationType";
import ProjectileLogic from "../components/ProjectileLogic";

/**
 * The main controller of the game.
 */
class GameController
{


    constructor()
    {
        this.app = PIXI.app;
        this.model = this.app.model;
        this.serverOnline = false;
        this.projCounter = 0;
        this.requestId = 1;

        this.eSys = new EntitySystem();
        this.app.eSys = this.eSys;

        this.eFactory = new EntityFactory();
        this.app.eFactory = this.eFactory;
    }


    showSplashScreen()
    {
        if (this.app.layout.getMobile())
        {
            this.app.dispatcher.on(C_GameEvt.SPLASH_CLOSED, this.setupApp, this);
            this.app.nav.setView(SplashScreen);
        }
        else
        {
            this.setupApp();
        }
    }


    setupApp()
    {
        window.postMessage('disableScroller', '*');
        // clear on reconnect
        if (this.webSocket)
        {
            console.log("Cleaning the old socket before reconnection");
            this.webSocket.destroy();
            delete this.websocket;
            this.webSocket = null;
            this.requestId = 1; // if we dont reset it, you get disconnected again
        }

        // set reconnection - true/false if you want to automatically reconnect on connection fail or not
        this.webSocket = io.connect(this.app.config.socketUrl, {reconnection : false});

        this.webSocket.on('connect_error', this.onConnectFail.bind(this));
        this.webSocket.on('connect', this.onSocketConnect.bind(this));
        this.webSocket.on('disconnect', this.onSocketClosed.bind(this));
    }


    onConnectFail(err)
    {
        console.log("Connection error");
        this.serverOnline = false;
        this.onConnect();
    }


    onSocketConnect() {
        this.serverOnline = true;
        this.onConnect();
        // this.loadTest();
    }


    onSocketClosed()
    {
        console.log("Socket disconnect");

        this.serverOnline = false;

        let msg = "You were disconnected from the server.\nDo you want to reconnect?";
        let win = new ConfirmWin(this.setupApp.bind(this), null, msg);
        this.app.stage.addChild(win);
    }


    // TODO remove test dynamic assets
    loadTest()
    {
        // call in before loading
        // this.app.assets.removeDynamic();
        let assets =
        [
            {name: "atlas4", file: "sheet4.json"}
        ];
        this.app.assets.addDynamic(assets, this.onConnect.bind(this));
    }


    generateRandomName()
    {
        let name;

        let N = MathUtil.getRandomInt(5, 15); //
        let s = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        name = Array(N+1).join((Math.random().toString(36)+'00000000000000000').slice(2, 18)).slice(0, N);

        return name;
    }


    onConnect()
    {

        let deviceId = this.app.model.isMobile() ? "mobile" : "web";

        let plCode = this.generateRandomName();

        let data =
        {
            request:C_Comm.INIT,
            startGameToken:
            {
                playerCode: plCode,
                gameCode: this.app.config.gameId,
                brandId: 0,
                currency: 'USD'
            },
            gameId : this.app.config.gameId,
            deviceId : deviceId
        };

        if (this.serverOnline)
        {
            this.webSocket.on(C_Comm.INIT, this.onInit.bind(this));
            this.webSocket.emit(C_Comm.INIT, data);
        }
        else
        {
            this.onInit(null);
        }
    }


    onInit(data)
    {
        if (this.serverOnline)
        {
            console.log(data);
            this.model.init(data);

            let reqData =
            {
                request : C_Comm.LIST_ROOMS,
                requestId : this.requestId++
            };
            console.log(reqData);
            this.webSocket.once(C_Comm.PLAY, this.onListRooms.bind(this));
            this.webSocket.emit(C_Comm.PLAY, reqData);
        }
        else
        {
            let fakeData =
            {
                result :
                {
                    rooms :
                    [
                        {
                            "type": "1",
                            "bet_list": [1,3,5,7,9],
                            "active": true
                        },
                        {
                            "type": "2",
                            "bet_list": [100],
                            "active": true
                        },
                        {
                            "type": "3",
                            "bet_list": [1000],
                            "active": false
                        }
                    ]
                }
            };
            this.onListRooms(fakeData);
        }
    }


    onListRooms(data)
    {
        console.log("list rooms");
        this.model.setRoomData(data);
        this.app.nav.setView(this.app.gFactory.getRoomSelectView());
        this.app.sound.playMusic(C_Snd.MENU_THEME);
    }


    goToRoomsMenu()
    {
        TweenMax.killDelayedCallsTo(this.stopNormalSpawners);
        TweenMax.killDelayedCallsTo(this.createFormationSpawners);
        TweenMax.killAll();

        this.webSocket.off(C_Comm.PLAY);
        this.app.nav.setView(this.app.gFactory.getRoomSelectView());
        this.app.sound.playMusic(C_Snd.MENU_THEME);
    }


    selectRoom(roomId)
    {
        if (this.serverOnline)
        {
            let roomData = this.model.getRoomData()[roomId];

            this.model.setBet(roomData.bet_list[0]);
            // this.model.setBet(100000); // Testing purposes
            this.model.setRoomId(roomId);

            let reqData =
            {
                request : C_Comm.ENTER_ROOM,
                requestId : this.requestId++,
                type : roomData.type
            };

            this.webSocket.once(C_Comm.PLAY, this.onRoomEntered.bind(this));
            this.webSocket.emit(C_Comm.PLAY, reqData);
        }
        else
        {
            let roomData = this.model.getRoomData()[roomId];
            this.model.setBet(roomData.bet_list[0]);
            this.model.setRoomId(roomId);
            let fakeData =
            {
                balance :
                {
                    currency : "USD",
                    amount : 1000000
                }
            }
            this.onRoomEntered(fakeData);
        }
    }


    onRoomEntered(data)
    {
        // this.model.setSelectedRoomData(data);
        // this.model.setBalance(data);
        // this.webSocket.on(C_Comm.PLAY, this.onPlayResponse.bind(this));
        //
        // this.startGame();

        this.model.setSelectedRoomData(data);
        this.model.setBalance(data);
        // this.app.nav.setView(this.app.gFactory.getTypeSelectView());
        this.selectType(C_ViewType.NORMAL);
    }


    selectType(viewType)
    {
        this.webSocket.on(C_Comm.PLAY, this.onPlayResponse.bind(this));
        this.startGame(viewType);
    }


    sendFakeResponse(targetId, isBomb = false)
    {
        let e = this.eSys.getEntityById(targetId);
        let l = e.getComponent(FlierLogic);
        let basePrice = FlierData.byType[l.flierType].prize;
        let data =
        {
            result :
            {
                coins_amount : basePrice*this.model.getBet(),
                rewards :
                [
                    targetId
                ],
                is_bomb : isBomb
            }
        }
        this.onPlayResponse(data);
    }


    onPlayResponse(data)
    {
        // console.log(JSON.stringify(data));

        this.model.setFireResponse(data);

        let killed = data.result.rewards.length > 0;

        // if(data.result.is_bomb && data.result.rewards.length > 1)
        if(data.result.is_bomb && data.result.rewards.length > 0)
        {
            this.app.nav.currentView.onFlareKilled();
            this.app.dispatcher.emit(C_GameEvt.PLAY_COINS_ANIM, null, data.result.coins_amount, true, false);
        }

        while (this.model.rewards.length > 0)
        {
            let killedId = this.model.rewards.pop();
            let killedEntity = this.eSys.getEntityById(killedId);

            if (killedEntity)
            {
                let p = killedEntity.getComponent(Physics);
                if (!data.result.is_bomb)
                {
                    let isBigWin = this.getFormType() == C_FormationType.RESCUE_MISSION;
                    this.app.dispatcher.emit(C_GameEvt.PLAY_COINS_ANIM, p, data.result.coins_amount, false, isBigWin);
                }

                let l = killedEntity.getComponent(FlierLogic);
                l.kill();
            }
        }

        if(data.result.is_bomb && killed)
        {
            let fliers = this.eSys.getEntitiesByType(C_Entity.FLIER);
            for (let fId in fliers)
            {
                let flier = fliers[fId];
                let l = flier.getComponent(FlierLogic);
                l.kill(true);
            }
        }
    }


    fire(bulletId, targetId, flierType, isBomb = false)
    {
        let d = new Date();

        let hitItems = [];
        if (!isBomb)
        {
            hitItems.push([flierType, targetId]);
        }
        else
        {
            let fliers = this.eSys.getEntitiesByType(C_Entity.FLIER);

            for (let entity in fliers)
            {
                let eId = fliers[entity].getId();
                let serverId = fliers[entity].getComponent(FlierLogic).getFlierServerId();
                hitItems.push([serverId, eId]);
            }
        }

        let reqData =
        {
            request : C_Comm.FIRE,
            requestId : this.requestId++,
            bullet_id : bulletId,
            bet_amount : this.model.getBet(),
            locked : false,
            timestamp : d.getTime(),
            // each item is [item_type_id, item_client_id]
            //hit_items : [[2, 123],[2, 232],[4, 323],[5,343],[102, 344],...],
            hit_items : hitItems,
            is_bomb : isBomb
        };

        this.webSocket.emit(C_Comm.PLAY, reqData);
    }


    startGame(viewType)
    {
        this.app.nav.setView(this.app.gFactory.getMainView());
        this.app.sound.playMusic(C_Snd.MAIN_THEME);

        this.eSys.setMainView(this.app.nav.currentView);

        this.initLevel(viewType);
    }


    // load dynamic assets then show paytable
    openPaytable()
    {
        // let assets =
        //     [
        //         {name: "atlas5", file: "PaytableAtlas.json"}
        //     ];
        //
        // this.app.assets.addDynamic(assets, this.showPaytable.bind(this));

        this.showPaytable();
    }


    showPaytable()
    {
        // this.paytableWin = new PaytableWin();
        this.paytableWin = this.app.gFactory.getPaytable();
        this.app.stage.addChild(this.paytableWin);
    }


    initLevel(viewType = C_ViewType.NORMAL)
    {
        this.model.unpause();
        this.model.coinsWon = 0;
        this.setGameVariables();
        this.setFormType(C_FormationType.STANDART);
        this.setFlierData(viewType);
        this.setCockpitsVars();
        this.eFactory.setViewType(viewType);
        // this.eFactory.createMoon();

        this.eFactory.createEnemySpawners();


        // TODO do those after the server says its Bonus Time

        let delay = 45;
        TweenMax.delayedCall(delay, this.stopNormalSpawners, [], this);
        TweenMax.delayedCall(delay + 4, this.createFormationSpawners, [], this);


        // this.eFactory.playRandomExplosion();

        // TODO uncomment bots
        this.eFactory.runBotsController();
        this.eSys.setTimeScale(4);
        this.eSys.start();
        this.eSys.botsCanShoot = true;
    }


    setGameVariables()
    {
        this.autoFireOn = false;
        this.targetLocked = false;
        this.clearTargetLock();
    }


    // TODO move to a different class when connected with the server
    setFormType(value)
    {
        this.formationType = value;
    }

    getFormType()
    {
        return this.formationType;
    }


    stopNormalSpawners()
    {
        let type = MathUtil.getRandomInt(1, 5);
        // type = C_FormationType.RESCUE_MISSION;
        this.setFormType(type);

        let text = C_FormationType.TEXTS[this.getFormType() - 1];
        this.app.nav.currentView.showBonusScreenText(text);
        this.eFactory.stopSpawners();
    }


    createFormationSpawners()
    {
        this.eSys.setTimeScale(4);
        this.eFactory.createFormationSpawner(this.getFormType());
    }


    setFlierData(viewType)
    {
        let data = (viewType == C_ViewType.TOP) ? FlierData.topShips : FlierData.normalShips;

        for (let i = 1; i <= 4; i++)
        {
            FlierData.byType[i] = data[i];
        }
    }


    startShooting(globalPt)
    {
        this.globalPt = globalPt;
        this.shoot();
    }


    updateShootPt(globalPt)
    {
        this.globalPt = globalPt;
    }


    getShootPt()
    {
        return this.globalPt;
    }


    setTargetReticle(reticle)
    {
        this.targetReticle = reticle;
    }


    lockTarget(id)
    {
        if (this.lockedTarget)
        {
            this.clearTargetLock()
        }

        this.lockedTarget = this.eSys.getEntityById(id);
        if (this.lockedTarget)
        {
            this.lockedTarget.isLocked = true;
            let s = this.lockedTarget.getComponent(GameSprite);

            // reticle
            if (this.targetReticle)
            {
                let mainReticle = this.app.nav.currentView.getReticle();
                mainReticle.alpha = 0;
                this.targetReticle.alpha = 1;
                s.setReticle(this.targetReticle);
            }
            else
            {
                s.showTarget();
            }
        }
    }


    clearTargetLock()
    {
        if (this.lockedTarget && this.lockedTarget.isLocked)
        {
            this.lockedTarget.isLocked = false;
            let s = this.lockedTarget.getComponent(GameSprite);

            if (this.targetReticle)
            {
                let mainReticle = this.app.nav.currentView.getReticle();
                mainReticle.alpha = 1;
                this.targetReticle.alpha = 0;
                s.setReticle(this.targetReticle);
            }
            else
            {
                s.hideTarget();
            }
        }
        this.lockedTarget = null;
    }


    stopShooting()
    {
        // TweenMax.killDelayedCallsTo(this.shoot);
        if (this.shootTween)
        {
            this.shootTween.kill();
            this.shootTween = null;
        }
    }


    shoot()
    {
        let canShoot = this.model.makeBet();

        if (this.shootTween)
        {
            this.shootTween.kill();
        }

        if (!canShoot)
        {
            return;
        }

        this.app.sound.playSound(C_Snd.WEAPON_SHOOT, .1);

        this.projCounter++;

        let relPt;
        relPt = this.app.layout.globalToRelative(this.globalPt);
        relPt.x *= 100;
        relPt.y *= 100;

        let shootVector;
        if (this.lockedTarget)
        {
            let l = this.lockedTarget.getComponent(FlierLogic);
            if (!l.isAlive())
            {
                this.clearTargetLock();
                this.autoFireOn = false;
                this.targetLocked = false;
                this.app.nav.currentView.stopShooting();
                return;
            }
            let p = this.lockedTarget.getComponent(Physics);
            shootVector = p.position.clone();
            shootVector.normalize();
            shootVector.scale(this.app.model.getProjectileVelocity());
        }
        else
        {
            shootVector = this.app.layout.projectScreenToGame(relPt);
            shootVector.normalize();
            shootVector.scale(this.app.model.getProjectileVelocity());
        }

        // TODO comment when not testing
        // shootVector = new Point3D(0, 0, 0);

        let pos;
        let projSize = (this.eFactory.getViewType() == C_ViewType.TOP) ? 0.25 : 2.5;

        let currRoomId = this.app.model.getRoomId();
        if (currRoomId == 0)
        {
            pos = this.getWeapPos(currRoomId, 0);
            let p = this.eFactory.getProjectile(pos, shootVector, projSize, null, null, this.lockedTarget);
            // p.getComponent(ProjectileLogic).isBeam = true;
            // p.getComponent(GameSprite).isBeam = true;
            this.eSys.queueEntityToAdd(p);
        }
        else if (currRoomId == 1)
        {
            projSize = 4;
            pos = this.getWeapPos(currRoomId, 0, true);

            let p = this.eFactory.getProjectile(pos, shootVector, projSize, null, null, this.lockedTarget);
            this.eSys.queueEntityToAdd(p);
            let s = p.getComponent(GameSprite);

            let localPt = this.app.nav.currentView.getReticlePosToLocal();
            let startPt = new Point3D(this.app.layout.relWidth(this.screenWeapPos[currRoomId][0].x),
                this.app.layout.relHeight(this.screenWeapPos[currRoomId][0].y), 0);
            let endPt = new Point3D(localPt.x, localPt.y, 0);
            let screenDistance = endPt.subtract(startPt);
            let distance = screenDistance.getLength();
            let scaleSize = 0.5 + (distance/this.app.layout.relHeight(100))*.8;
            scaleSize = MathUtil.clamp(scaleSize, 0.5, 1);
            s.scaleAspect(scaleSize);

            let parentProjLogic = p.getComponent(ProjectileLogic);

            pos = this.getWeapPos(currRoomId, 1, true);
            p = this.eFactory.getProjectile(pos, shootVector, projSize, null, null, this.lockedTarget, parentProjLogic);
            this.eSys.queueEntityToAdd(p);
            s = p.getComponent(GameSprite);

            startPt = new Point3D(this.app.layout.relWidth(this.screenWeapPos[currRoomId][1].x),
                this.app.layout.relHeight(this.screenWeapPos[currRoomId][1].y), 0);
            endPt = new Point3D(localPt.x, localPt.y, 0);
            screenDistance = endPt.subtract(startPt);
            distance = screenDistance.getLength();
            scaleSize = 0.5 + (distance/this.app.layout.relHeight(100))*.5;
            scaleSize = MathUtil.clamp(scaleSize, 0.5, 1);
            s.scaleAspect(scaleSize);
        }
        else
        {
            pos = this.getWeapPos(currRoomId, 0, true);
            let p = this.eFactory.getProjectile(pos, shootVector, projSize, null, null, this.lockedTarget);
            this.eSys.queueEntityToAdd(p);

            let parentProjLogic = p.getComponent(ProjectileLogic);

            pos = this.getWeapPos(currRoomId, 1, true);
            p = this.eFactory.getProjectile(pos, shootVector, projSize, null, null, this.lockedTarget, parentProjLogic);
            this.eSys.queueEntityToAdd(p);

            pos = this.getWeapPos(currRoomId, 2);
            p = this.eFactory.getProjectile(pos, shootVector, projSize, null, null, this.lockedTarget, parentProjLogic);
            this.eSys.queueEntityToAdd(p);
        }

        let amplitude = this.app.layout.relWidth(.15);
        this.app.layout.shake(this.app.nav.currentView, .3, amplitude, amplitude, .9, 0);
        this.shootTween = TweenMax.delayedCall(.2, this.shoot, [], this);
    }


    getWeapPos(roomId, weapId, checkRotation = false, z = 20)
    {
        let cv = this.app.nav.currentView;
        let weapRelPos = this.screenWeapPos[roomId][weapId].clone();

        if (checkRotation)
        {
            let weap = cv.weapons[weapId];

            let visualRotation = weap.rotation - this.weapOffRotation[roomId][weapId];
            visualRotation -= Math.PI * .5;

            let r = this.weaponHeight[roomId];
            let xDif = r*Math.cos(visualRotation);
            let yDif = r*Math.sin(visualRotation);

            weapRelPos.x += xDif;
            weapRelPos.y += yDif;
        }

        // TODO check anchors because there is a little offset right now

        let weapPos = new PIXI.Point(this.app.layout.relWidth(weapRelPos.x), this.app.layout.relHeight(weapRelPos.y));
        weapPos = cv.mainContainer.toLocal(cv.toGlobal(weapPos));
        let weapScreenToGame = this.app.layout.projectScreenToGame3D(weapPos, z);

        return weapScreenToGame;
    }


    // TODO move the below methods in appropriate class (weapon class, including number of weapons)
    setCockpitsVars()
    {
        // point (0, 0) is the center
        // @ landscape :
        // this.weapPercPos = [new PIXI.Point(14, 37), new PIXI.Point(17.2, 26.2), new PIXI.Point(15, 25.8)];
        // @ portrait :
        this.screenWeapPos = [
            [new PIXI.Point(50, 87)],
            // [new PIXI.Point(16.7, 95.312), new PIXI.Point(83.3, 95.312)], // TODO remove test
            [new PIXI.Point(18, 95), new PIXI.Point(82, 95)],
            [new PIXI.Point(26.9, 95.312), new PIXI.Point(73.1, 95.312), new PIXI.Point(50, 90)]];
        this.weaponHeight = [0, 14, 10]; // used for weapon rotation stuff
        // rotation limits
        this.weapRotationLimits = {
            0 : [],
            1 : [
                new PIXI.Point(Math.PI/8, Math.PI*2), // left weapon min and max limits
                new PIXI.Point(0, Math.PI*15/8) // right weapon min and max limits
            ],
            2 : [
                new PIXI.Point(Math.PI/4, Math.PI*2 - Math.PI/12), // left weapon min and max limits
                new PIXI.Point(Math.PI/12, Math.PI*2 - Math.PI/4) // right weapon min and max limits
            ]
        }
        this.weapOffRotation = {
            0 : [],
            1 : [-Math.PI/12, Math.PI/12],
            2 : [-Math.PI/12, Math.PI/12]
        }
    }


    getRelWeapPos(weapId)
    {
        return this.screenWeapPos[this.app.model.getRoomId()][weapId];
    }


    updateWeaponsRotation(pt)
    {
        for (let weapon in this.app.nav.currentView.weapons)
        {
            let weap = this.app.nav.currentView.weapons[weapon];
            if (weap)
            {
                let relPt = this.app.layout.globalToRelative(pt);
                relPt.x *= 100;
                relPt.y *= 100;
                let ptX = this.app.layout.relWidth(relPt.x);
                let ptY = this.app.layout.relHeight(relPt.y);

                let weapX = this.app.layout.relWidth(weap.propWidth);
                let weapY = this.app.layout.relHeight(weap.propHeight);

                let angleDeg = Math.atan2(ptX - weapX, ptY - weapY);

                // console.log(angleDeg);

                let rotation = this.getWeaponRotation(angleDeg, weapon);


                // let pi = Math.PI;
                // let rotation = pi - angleDeg;
                // if (rotation > pi/8 && rotation < pi)
                // {
                //     rotation = pi/8;
                // }
                // else if (rotation > pi)
                // {
                //     rotation = 2*pi;
                // }
                weap.rotation =  rotation;
            }
        }
    }


    getWeaponRotation(angle, weapId)
    {
        let pi = Math.PI;
        let rotation = pi - angle;

        let room = this.model.getRoomId();
        // console.log(room);

        // return;
        let limit1 = this.weapRotationLimits[room][weapId].x;
        let limit2 = this.weapRotationLimits[room][weapId].y;

        if (rotation > limit1 && rotation < pi)
        {
            rotation = limit1;
        }
        else if (rotation > pi && rotation < limit2)
        {
            rotation = limit2;
        }

        rotation += this.weapOffRotation[room][weapId];

        return rotation;
        // if (rotation > pi/8 && rotation < pi)
        // {
        //     rotation = pi/8;
        // }
        // else if (rotation > pi && rotation < pi*2)
        // {
        //     rotation = 2*pi;
        // }
        //
        // if (rotation > 0 && rotation < pi)
        // {
        //     rotation = 0
        // }
        // else if (rotation > pi && rotation < pi*15/8)
        // {
        //     rotation = pi * 15/8;
        // }
    }


}


export default GameController;